import { FeatureServiceProviderDefinition, FeatureServices } from '@feature-hub/core';
import {
  defineTrackingServiceConfig,
  SharedTrackingServiceConfig,
} from '@volkswagen-onehub/tracking-service-config';
import { BrandIdentifier } from '@volkswagen-onehub/gfa-dealer-context-service';

export interface EnvironmentData {
  readonly applicationId: string;
  readonly language: string;
  readonly countryCode: string;
  readonly currency: string;
  readonly market: string;
  readonly brand: BrandIdentifier;
}

export function createTrackingServiceConfig(
  trackingData: EnvironmentData,
): FeatureServiceProviderDefinition<SharedTrackingServiceConfig, FeatureServices> {
  const { countryCode, language, applicationId } = trackingData;
  const breakPoints = [560, 960, 1280, 1600, 1920, 2560];
  const trackingServiceConfigDefinition = defineTrackingServiceConfig({
    environmentData: { country: countryCode, language, applicationId },
    breakPoints,
    navigationDataFn: () => {
      return {
        pageName: 'VW DGA Integrator',
      };
    },
    provider: {
      push: (event: unknown): void => {
        console.info('Tracking Event:', event);
      },
    },
  });
  return trackingServiceConfigDefinition;
}
